import { getAirbrake } from "@simplybusiness/services";
import { useMutation } from "@tanstack/react-query";
import {
  AIRBRAKE_PROJECT_ID,
  AIRBRAKE_PROJECT_KEY,
} from "../../constants/constants";
import { apiRequest } from "../../utils/apiRequest";
import { useTokensValues } from "../tokens";
import type { Layout } from "../../components/CoverTogglesContainer/ExperimentGridView/LayoutToggle";

const airbrake = getAirbrake({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY,
});

/**
 * This hook is used to store a user's layout preference in Chopin using a
 * step_action. It is triggered when changing a LayoutToggle.
 */
export const useToggleLayoutPreference = () => {
  const tokens = useTokensValues();

  const mutation = useMutation({
    mutationFn: (quotesLayoutPreference: Layout) =>
      apiRequest("?step_action=toggle_layout_preference", {
        ...tokens,
        quotesLayoutPreference,
      }),
    mutationKey: ["toggleLayoutPreference"],
  });

  const { isPending, isError, error, isSuccess, mutate } = mutation;

  const toggleLayoutPreference = (quotesLayoutPreference: Layout) => {
    mutate(quotesLayoutPreference, {
      onSuccess: () => {}, // No response to handle
      onError: (error: Error) => {
        console.error(`Error toggling layout preference: ${error.message}`);
        void airbrake.notify(error);
      },
    });
  };

  return {
    toggleLayoutPreference,
    isSuccess,
    isPending,
    isError,
    error,
  };
};
